import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const CityReducer = createSlice({
  name: "City",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("CityReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = CityReducer;
export const { defaultAction } = actions;
export default reducer;
